export const isImageOrPdf = (mimeType: string) => {
  // checks if string is 'image/*' or 'application/pdf'
  const regex = /^(image\/.+|application\/pdf)$/;
  return regex.test(mimeType);
};
